// Sticky Elements

$(document).ready(function () {
  var footerBottomAdjust = $('.c-footer').height() + 200;
  $(".c-sticky").sticky({
    topSpacing: 45,
    bottomSpacing: 750
  });
});

